import { appConfig } from '../config/runtimeConfig';

export type CurrencyOption = {
  code: string;
  symbol: string;
  label: string;
};

const ALL_CURRENCIES: CurrencyOption[] = [
  { code: 'gbp', symbol: '£', label: '£ - GBP' },
  { code: 'usd', symbol: '$', label: '$ - USD' },
  { code: 'eur', symbol: '€', label: '€ - EUR' },
  { code: 'scr', symbol: '₨', label: '₨ - SCR' },
  { code: 'zar', symbol: 'R', label: 'R - ZAR' },
];

const brandCurrencyCodes =
  appConfig.APP_BRAND === 'ellipsis'
    ? ['gbp', 'usd', 'eur', 'scr']
    : ['gbp', 'usd', 'eur', 'zar'];

export const supportedCurrencies: CurrencyOption[] = ALL_CURRENCIES.filter(
  (currency) => brandCurrencyCodes.includes(currency.code)
);

export const allowedCurrencies = supportedCurrencies.map(
  (currency) => currency.code
);

export const defaultCurrency =
  appConfig.APP_BRAND === 'ellipsis' ? 'eur' : 'zar';

export function lookupCurrencySymbol(currencyCode: string) {
  const currencyCodeToCheck = currencyCode.toLowerCase();
  const match = ALL_CURRENCIES.find(
    (currency) => currency.code === currencyCodeToCheck
  );
  return match?.symbol || currencyCode;
}
